import { render } from "./MatchTypeValue.vue?vue&type=template&id=4c5cabb9&scoped=true"
import script from "./MatchTypeValue.vue?vue&type=script&lang=js"
export * from "./MatchTypeValue.vue?vue&type=script&lang=js"

import "./MatchTypeValue.vue?vue&type=style&index=0&id=4c5cabb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5cabb9"]])

export default __exports__